import { t } from 'i18next';
import React, { CSSProperties } from 'react';
import ReactModal from 'react-modal';
import { GameType } from '@sparted/shared-library/business/types';

import UButton from 'Components/unit/UButton/UButton';
import UIconButton from 'Components/unit/UIconButton/UIconButton';
import SPhoneFrame from 'Components/structural/SPhoneFrame/SPhoneFrame';
import SQRCodeIndicator from 'Components/structural/SQRCodeIndicator/SQRCodeIndicator';
import UIconTab from 'Components/unit/UIconTab/UIconTab';

import styles, { modalStyle } from './MGameplayPreview.style';

type Props = {
  title: string;
  subtitle: string;
  url: string;
  onCloseModal: () => void;
  visible?: boolean;
  qrCodeLabel?: string;
  refreshLabel?: string;
  onRefresh?: () => void;
  style?: CSSProperties;
  gameplay: GameType;
};

type State = {
  refreshToggle: boolean;
};

const gameplayLabelMap = {
  mcq: () => t('gameplays:mcq.label'),
  'error-text': () => t('gameplays:error_text.label'),
  'no-interaction': () => t('gameplays:no_interaction_content.label'),
  'open-question': () => t('gameplays:open_question.label'),
  'ordering-cards': () => t('gameplays:ordering_cards.label'),
  'picture-spot': () => t('gameplays:picture_spot.label'),
  'swiping-cards': () => t('gameplays:swiping_cards.label'),
};

export class MGameplayPreview extends React.Component<Props, State> {
  static defaultProps = {
    visible: false,
    qrCodeLabel: '',
    refreshLabel: '',
    onRefresh: undefined,
    style: undefined,
  };

  state = {
    refreshToggle: false,
  };

  constructor(props: Props) {
    super(props);

    ReactModal.setAppElement('body');
  }

  render() {
    const { visible, style } = this.props;

    return (
      <div style={style}>
        <ReactModal isOpen={!!visible} onRequestClose={this.handleCloseModal} style={modalStyle}>
          <div style={styles.bodyContainer}>
            {this.renderPreviewPanel()}
            {this.renderInformationPanel()}
          </div>
        </ReactModal>
      </div>
    );
  }

  renderPreviewPanel = () => {
    const { url } = this.props;
    const { refreshToggle } = this.state;

    return (
      <div style={styles.previewPanel}>
        <div style={styles.phoneFrameWrapper}>
          <SPhoneFrame url={url} toggleReload={refreshToggle} />
          {this.renderRefreshButton()}
        </div>
      </div>
    );
  };

  renderRefreshButton = () => {
    const { refreshLabel } = this.props;

    return (
      <UButton
        text={refreshLabel || t('gameplays:restart_game')}
        leftIcon="refresh"
        onClick={this.handleToggleRefresh}
        style={styles.refreshButton}
      />
    );
  };

  renderInformationPanel = () => {
    const { subtitle, url, qrCodeLabel, gameplay, title } = this.props;

    return (
      <div style={styles.informationPanel}>
        <div style={styles.actionContainer}>
          <UIconButton icon="close-light" onClick={this.handleCloseModal} ghost />
        </div>
        <div style={styles.titleContainer}>
          <div style={{ display: 'flex' }}>
            <UIconTab iconType={gameplay} selected locked size="M" />
            <div style={styles.label}>{gameplayLabelMap[gameplay]()}</div>
          </div>
          <span style={styles.title}>{title}</span>
          <span style={styles.subtitle}>#{subtitle}</span>
        </div>
        <SQRCodeIndicator
          qrContent={url}
          title={qrCodeLabel}
          size={styles.qrCode.width}
          style={styles.qrCodeContainer}
        />
      </div>
    );
  };

  handleToggleRefresh = () => {
    const { onRefresh } = this.props;
    const { refreshToggle } = this.state;

    this.setState({ refreshToggle: !refreshToggle });

    if (onRefresh) onRefresh();
  };

  handleCloseModal = () => {
    const { onCloseModal } = this.props;

    onCloseModal();
  };
}

export default MGameplayPreview;
